import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  HeaderFlex,
  HeaderGrid,
  TopNav,
  LogoImg,
  MenuFlex,
  MenuFlexItem,
  CTAButton,
  AboveFoldSection,
  Height,
  TopPart,
  ContentFlexer,
  RelativeBox,
  ColumnFlex,
  SmallHeading,
  MainHeading,
  ButtonHolder,
  SmallTextHolder,
  SmallText,
  PermanentCTAButton,
  PointerandProof,
  ThreePointers,
  PointerHolder,
  Pointer,
  Step,
  StepDesc,
  Fonter,
  StepTitle,
  CTAandProof,
  CTAHolder,
  Wrapper,
  WrapperFlexer,
  DarkSection,
  Benefits,
  DarkTitle,
  BenefitsFlex,
  Benefit,
  IconTitle,
  BenefitTitle,
  BenefitSpacer,
  BenefitsPara,
  DarkCTAHolder,
  BenefitsCTAHolder,
  ListingSample,
  GridContentHolder,
  SampleHeader,
  SampleBold,
  FancyHolder,
  FancyChild,
  HamWrapper,
  FancyImg,
  FancyContentHolder,
  StartFlowButton,
  ListingDetail,
  ListingDetailBold,
  ListingDetailValue,
  LogoWrapper,
  LogoAnchor,
  DrawerMenuItems,
  GridFiller,
  HeaderLine,
  BottomFlexer,
  DarkTitleBottom,
  DarkSubtitleBottom,
  HeaderGridFiller,
  StickyReviews,
  ReviewLogo,
  ReviewRightSide,
  RightSideTop,
  StarFlexer,
  StarSpan,
  StarsHolder,
  StarContainer,
  RatingHolder,
  MiniLogo,
  ReviewFlex,
  ReviewHolder,
  ReviewTextHolder,
  ReviewHeading,
  ReviewBody,
  ReviewGrid,
  ReviewReadMore,
  ReadMoreLink,
} from "../../../styles/LPStyles";
import img from "../../../public/images/logo.svg";
import {
  Avatar,
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import NextImage from "next/image";
import whiteLogo from "../../../public/images/whiteLogo.svg";
import Head from "next/head";
import { RiPriceTag3Fill } from "react-icons/ri";
import {
  AiFillEye,
  AiFillStar,
  AiOutlineStar,
  AiOutlineTrophy,
} from "react-icons/ai";
import { FaSearchLocation } from "react-icons/fa";
import { MdFilterCenterFocus, MdMenu } from "react-icons/md";
import Link from "next/link";
import { BiBuildingHouse, BiConversation, BiUserCircle } from "react-icons/bi";
import { BsChevronRight, BsPeopleFill } from "react-icons/bs";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { clientAnalytics } from "../../../utils/utilties";
import ReviewsBadge from "../../../components/ReviewsBadge";
const LP = ({ type, pageData }) => {
  const router = useRouter();

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    // only execute all the code below in client side
    if (typeof window !== "undefined") {
      // Handler to call on window scroll
      function handleScroll() {
        // Set window width/height to state
        if (window?.scrollY > 20) {
          setScroll(true);
        } else {
          setScroll(false);
        }
      }

      // Add event listener
      window.addEventListener("scroll", handleScroll);

      // Call handler right away so state gets updated with initial window size
      handleScroll();

      // Remove event listener on cleanup
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);

  const ctaText = "Continue";

  const scrollTo = (prop) => {
    router.push(prop);
    onClose();
  };
  const MenuFlexItems = (
    <>
      <MenuFlexItem
        onClick={() => {
          scrollTo("#explore");
        }}
      >
        <BiBuildingHouse color="white" size="21px" />
        Explore
      </MenuFlexItem>

      <MenuFlexItem
        onClick={() => {
          scrollTo("#reviews");
        }}
      >
        <AiOutlineStar color="white" size="21px" />
        Reviews
      </MenuFlexItem>

      <MenuFlexItem
        onClick={() => {
          scrollTo("#whyus");
        }}
      >
        <AiOutlineTrophy color="white" size="21px" />
        Why us
      </MenuFlexItem>

      <MenuFlexItem
        onClick={() => {
          router.push("/signup");
        }}
      >
        <BiUserCircle color="white" size="21px" />
        Sign in
      </MenuFlexItem>
    </>
  );
  const { isOpen, onOpen, onClose } = useDisclosure();

  const StartQuiz = (hook) => {
    router.push({
      pathname: `/path/${type}`,
      query: {
        CTA: hook,
        buttonText: ctaText,
      },
    });
  };
  return (<>
    <Head>
      <title>{type} listings in Canada | Zonado.com</title>
      <meta
        key="og:title"
        property="og:title"
        content={type + " listings in Canada | Zonado.com"}
      />
      <meta
        key="og:description"
        property="og:description"
        content={pageData?.metaDesc}
      />
      <meta
        key="og:image"
        property="og:image"
        content={`/images/lp/${type}/hero.jpg`}
      />
      <link
        key="fav1"
        rel="apple-touch-icon"
        sizes="180x180"
        href="../../../../favicons/apple-touch-icon.png"
      />
      <link
        key="fav2"
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="../../../../favicons/favicon-32x32.png"
      />
      <link
        key="fav3"
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="../../../../favicons/favicon-16x16.png"
      />
      <link
        key="fav4"
        rel="manifest"
        href="../../../../favicons/site.webmanifest"
      />
      <link
        key="fav5"
        rel="mask-icon"
        href="../../../../favicons/safari-pinned-tab.svg"
        color="#125f3f"
      />
      <link
        key="fav6"
        rel="shortcut icon"
        href="../../../../favicons/favicon.ico"
      />
      <link
        rel="canonical"
        href={`https://zonado.com/lp/${router.query.type}`}
      />
      <meta
        key="msFav"
        name="msapplication-config"
        content="../../../favicons/browserconfig.xml"
      />
    </Head>
    <Fonter>
      <TopNav scroll={scroll}>
        <HeaderFlex>
          <HeaderGrid scroll={scroll}>
            <HeaderGridFiller>
              <LogoAnchor scroll={scroll} href="/login">
                <LogoImg tabIndex={-1} src={whiteLogo} alt="Zonado Logo" />
              </LogoAnchor>

              <MenuFlex scroll={scroll}>{MenuFlexItems}</MenuFlex>

              <HeaderLine scroll={scroll}>
                <span>{pageData?.floater[0]}</span>
                <Box margin="0 10px">//</Box>
                <span>{pageData?.floater[1]}</span>
              </HeaderLine>

              <HamWrapper scroll={scroll} onClick={onOpen}>
                <MdMenu size="40px" color="white" />
              </HamWrapper>

              <CTAButton
                scroll={scroll}
                onClick={() => StartQuiz("Header CTA")}
              >
                {ctaText}
              </CTAButton>
            </HeaderGridFiller>
          </HeaderGrid>
        </HeaderFlex>
      </TopNav>

      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader h="64px">
            <Link href={"/signup"}>
              <LogoWrapper tabIndex={-1}>
                <LogoImg tabIndex={-1} src={img} alt="Zonado Logo" />
              </LogoWrapper>
            </Link>
          </DrawerHeader>

          <DrawerBody fontFamily={"inherit"} paddingLeft="0px">
            <div>
              <DrawerMenuItems
                onClick={() => {
                  scrollTo("#explore");
                }}
              >
                <BiBuildingHouse color="black" size="25px" />
                Explore
              </DrawerMenuItems>

              <DrawerMenuItems
                onClick={() => {
                  scrollTo("#reviews");
                }}
              >
                <AiOutlineStar color="black" size="25px" />
                Reviews
              </DrawerMenuItems>

              <DrawerMenuItems
                onClick={() => {
                  scrollTo("#whyus");
                }}
              >
                <AiOutlineTrophy color="black" size="25px" />
                Why us
              </DrawerMenuItems>

              <DrawerMenuItems
                onClick={() => {
                  router.push("/signup");
                }}
              >
                <BiUserCircle color="black" size="25px" />
                Sign in
              </DrawerMenuItems>
            </div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <AboveFoldSection>
        <Height>
          <TopPart>
            <div>
              <NextImage
                src={`/images/lp/${type}/hero.jpg`}
                alt={`${type} hero`}
                // position="absolute"
                // width="100%"
                priority
                fill
                sizes="100vw" />
            </div>
            <ContentFlexer>
              <RelativeBox>
                <GridFiller>
                  <ColumnFlex>
                    <SmallHeading>{pageData?.subText}</SmallHeading>

                    <MainHeading>{pageData?.hero}</MainHeading>

                    <ButtonHolder>
                      <PermanentCTAButton
                        onClick={() => StartQuiz("Hero CTA")}
                        color="red"
                        scroll={scroll}
                      >
                        {ctaText}
                      </PermanentCTAButton>
                    </ButtonHolder>

                    <SmallTextHolder>
                      <SmallText>
                        100+ new listings posted every week by property owners
                        and agents across Canada.
                      </SmallText>
                    </SmallTextHolder>
                  </ColumnFlex>
                </GridFiller>
              </RelativeBox>
            </ContentFlexer>
          </TopPart>

          <IconButton
            onClick={() => {
              scrollTo("#scroll");
            }}
            fontSize="40px"
            aria-label=""
            backgroundColor="#fdfdfd"
            bottom="-20px"
            left="50%"
            transform="translateX(-50%)"
            position="absolute"
            size={"lg"}
            color="red.500"
            borderRadius="50%"
            icon={<ChevronDownIcon />}
          />
        </Height>
      </AboveFoldSection>

      <PointerandProof id="scroll">
        <WrapperFlexer>
          <Wrapper>
            <ThreePointers>
              <PointerHolder>
                <Pointer>
                  {/* <Image src={'/images/lp/pointer.jfif'}
                                  size={"64px"}
                                  /> */}
                  <BiConversation size="44px" color="#233034" />

                  <Step>Step 1</Step>
                  <StepTitle>
                    Tell us about your {pageData?.stepText}
                  </StepTitle>
                  <StepDesc>
                    {" "}
                    Take our 40-second quiz. Tell us about your needs and
                    preferences.{" "}
                  </StepDesc>
                </Pointer>

                <Pointer>
                  <MdFilterCenterFocus size="44px" color="#233034" />
                  <Step>Step 2</Step>
                  <StepTitle>Get personalized recommendations</StepTitle>
                  <StepDesc>
                    Let our smart engine find on and off market listings that
                    match your requirements.
                  </StepDesc>
                </Pointer>

                <Pointer>
                  {/* <Image src={'/images/lp/pointer.jfif'}
                                      size={"64px"}
                                  /> */}

                  <BsPeopleFill size="44px" color="#233034" />
                  <Step>Step 3</Step>
                  <StepTitle>Contact the seller or agent directly</StepTitle>
                  <StepDesc>
                    Use Zonado's in-app messaging to contact sellers or agents
                    directly, absolutely free
                  </StepDesc>
                </Pointer>
              </PointerHolder>
            </ThreePointers>

            <CTAandProof>
              <CTAHolder>
                <PermanentCTAButton
                  onClick={() => StartQuiz("Under Top 3 Pointers")}
                  color="black"
                >
                  {ctaText}
                </PermanentCTAButton>
              </CTAHolder>

              {/* <ProofHolder>
                              <ProofImg src={'/images/lp/proof.png'} />
                              <ProofImg src={'/images/lp/proof.png'} />
                              <ProofImg src={'/images/lp/proof.png'} />
                              <ProofImg src={'/images/lp/proof.png'} />
                              <ProofImg src={'/images/lp/proof.png'} />
                              <ProofImg src={'/images/lp/proof.png'} />

                          </ProofHolder> */}
            </CTAandProof>
          </Wrapper>
        </WrapperFlexer>
      </PointerandProof>

      <DarkSection id="whyus">
        <WrapperFlexer>
          <Wrapper>
            <Benefits>SEARCHING WITH BENEFITS</Benefits>

            <DarkTitle>Why choose Zonado?</DarkTitle>

            <BenefitsFlex>
              <Benefit>
                <IconTitle>
                  <Box
                    mr="1rem"
                    color="#c6c6c6"
                    as={RiPriceTag3Fill}
                    w={{ base: "28px", md: "35px" }}
                    h={{ base: "28px", md: "35px" }}
                  />
                  $1.5 Billion +
                </IconTitle>

                <BenefitTitle>Worth of active listings</BenefitTitle>

                <BenefitSpacer />

                <BenefitsPara>
                  Gain access to on and off-market listings from across
                  Canada. Invest where your money will work the hardest.
                </BenefitsPara>
              </Benefit>

              <Benefit>
                <IconTitle>
                  <Box
                    mr="1rem"
                    color="#c6c6c6"
                    as={AiFillEye}
                    w={{ base: "28px", md: "35px" }}
                    h={{ base: "28px", md: "35px" }}
                  />
                  100K+
                </IconTitle>

                <BenefitTitle>Views of Zonado listings</BenefitTitle>

                <BenefitSpacer />

                <BenefitsPara>
                  Zonado listings instantly reach a wide and quality audience.
                  Results follow quickly.
                </BenefitsPara>
              </Benefit>

              <Benefit>
                <IconTitle>
                  <Box
                    mr="1rem"
                    color="#c6c6c6"
                    as={FaSearchLocation}
                    w={{ base: "28px", md: "35px" }}
                    h={{ base: "28px", md: "35px" }}
                  />
                  10K+
                </IconTitle>

                <BenefitTitle>Canadian searchers</BenefitTitle>

                <BenefitSpacer />

                <BenefitsPara>
                  Including investors, agents, and service providers from
                  coast to coast.
                </BenefitsPara>
              </Benefit>

              <Benefit>
                <IconTitle>
                  <Box
                    mr="1rem"
                    color="#c6c6c6"
                    as={RiPriceTag3Fill}
                    w={{ base: "28px", md: "35px" }}
                    h={{ base: "28px", md: "35px" }}
                  />
                  $0 Fee
                </IconTitle>

                <BenefitTitle>For investors</BenefitTitle>

                <BenefitSpacer />

                <BenefitsPara>
                  Connect with sellers directly, absolutely free. Listing
                  owners pay a fee to promote their property.
                </BenefitsPara>
              </Benefit>
            </BenefitsFlex>

            <BenefitsCTAHolder>
              <PermanentCTAButton
                onClick={() => StartQuiz("4 Benefits CTA")}
                color="white"
              >
                {ctaText}
              </PermanentCTAButton>
            </BenefitsCTAHolder>
          </Wrapper>
        </WrapperFlexer>
      </DarkSection>

      <ListingSample beige={false} name="reviews">
        <WrapperFlexer>
          <Wrapper>
            <GridContentHolder>
              <SampleHeader>PEOPLE LOVE SEARCHING WITH ZONADO</SampleHeader>

              <SampleBold>
                We’ve already helped thousands of investors find{" "}
                {pageData?.helpText}
              </SampleBold>

              <ReviewGrid>
                <ReviewHolder>
                  <ReviewFlex>
                    <ReviewTextHolder>
                      <Flex>
                        <Avatar
                          size="xs"
                          mr="8px"
                          src={"/images/lp/marie.jpeg"}
                        />
                        <p>Marie Canonaco</p>
                      </Flex>
                      <ReviewHeading>Very helpful platform</ReviewHeading>

                      <StarSpan>
                        <StarFlexer>
                          {[...Array(5)].map((e, i) => (
                            <StarContainer key={i}>
                              <AiFillStar color="#f2962d" size="16px" />
                            </StarContainer>
                          ))}
                        </StarFlexer>
                      </StarSpan>
                      <ReviewBody>
                        Very helpful platform providing excellent filters to
                        help sort through inventory to help me find the best
                        fit.
                        <ReviewReadMore>
                          ...{" "}
                          <ReadMoreLink
                            onClick={() => {
                              clientAnalytics.track(
                                "Review link visited on LP"
                              );
                            }}
                            href="https://trstp.lt/kmkJRC-go"
                          >
                            Read more
                          </ReadMoreLink>
                        </ReviewReadMore>
                      </ReviewBody>
                    </ReviewTextHolder>
                  </ReviewFlex>
                </ReviewHolder>
                <ReviewHolder>
                  <ReviewFlex>
                    <ReviewTextHolder>
                      <Flex>
                        <Avatar
                          size="xs"
                          mr="8px"
                          src={"/images/lp/chamkaur.jpg"}
                        />
                        <p>Chamkaur Singh</p>
                      </Flex>
                      <ReviewHeading>
                        It is already my go-to website
                      </ReviewHeading>

                      <StarSpan>
                        <StarFlexer>
                          {[...Array(5)].map((e, i) => (
                            <StarContainer key={i}>
                              <AiFillStar color="#f2962d" size="16px" />
                            </StarContainer>
                          ))}
                        </StarFlexer>
                      </StarSpan>
                      <ReviewBody>
                        Is very well designed, with flexible filters, and easy
                        to use. I am very satisfied with it. It is already
                        become a go to website for my real estate needs in
                        Canada. I recommend you go on Zonado regularly.
                        <ReviewReadMore>
                          ...{" "}
                          <ReadMoreLink
                            onClick={() => {
                              clientAnalytics.track(
                                "Review link visited on LP"
                              );
                            }}
                            href="https://goo.gl/maps/hfhZypdxft2L71KB8"
                          >
                            Read more
                          </ReadMoreLink>
                        </ReviewReadMore>
                      </ReviewBody>
                    </ReviewTextHolder>
                  </ReviewFlex>
                </ReviewHolder>
              </ReviewGrid>
            </GridContentHolder>
          </Wrapper>
        </WrapperFlexer>
        <CTAandProof>
          <CTAHolder>
            <PermanentCTAButton
              onClick={() => StartQuiz("CTA under Reviews")}
              color="black"
            >
              {ctaText}
            </PermanentCTAButton>
          </CTAHolder>
        </CTAandProof>
      </ListingSample>

      <ListingSample beige={true} name="explore">
        <WrapperFlexer>
          <Wrapper>
            <GridContentHolder>
              <SampleHeader>WHAT'S CURRENTLY AVAILABLE?</SampleHeader>

              <SampleBold>
                Take a closer look at some of the trending{" "}
                {type?.toLowerCase()} listings
              </SampleBold>

              <FancyHolder>
                <FancyChild
                  onClick={() => {
                    StartQuiz("Listing card");
                  }}
                >
                  <FancyImg
                    special={true}
                    src={`/images/lp/${type}/sample1.jpg`}
                  />

                  <FancyContentHolder special={true}>
                    <StartFlowButton>
                      {pageData?.samples && pageData?.samples[0]?.heading}
                      <BsChevronRight color="black" size="20px" />
                    </StartFlowButton>

                    <ListingDetail>
                      <ListingDetailBold>Location</ListingDetailBold>

                      <ListingDetailValue underLine={true}>
                        {pageData?.samples && pageData?.samples[0]?.location}
                      </ListingDetailValue>
                    </ListingDetail>

                    <ListingDetail>
                      <ListingDetailBold>PRICE</ListingDetailBold>

                      <ListingDetailValue>
                        {pageData?.samples && pageData?.samples[0]?.price}
                      </ListingDetailValue>
                    </ListingDetail>

                    {pageData?.samples && pageData?.samples[0]?.cap && (
                      <ListingDetail>
                        <ListingDetailBold>CAP</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[0]?.cap}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}

                    {pageData?.samples && pageData?.samples[0]?.size && (
                      <ListingDetail>
                        <ListingDetailBold>Size</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[0]?.size}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}

                    {pageData?.samples && pageData?.samples[0]?.units && (
                      <ListingDetail>
                        <ListingDetailBold>Units</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[0]?.units}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}
                  </FancyContentHolder>
                </FancyChild>

                <FancyChild
                  onClick={() => {
                    StartQuiz("Listing card");
                  }}
                >
                  <FancyImg src={`/images/lp/${type}/sample2.jpg`} />

                  <FancyContentHolder>
                    <StartFlowButton>
                      {pageData?.samples && pageData?.samples[1]?.heading}
                      <BsChevronRight color="black" size="20px" />
                    </StartFlowButton>

                    <ListingDetail>
                      <ListingDetailBold>Location</ListingDetailBold>

                      <ListingDetailValue underLine={true}>
                        {pageData?.samples && pageData?.samples[1]?.location}
                      </ListingDetailValue>
                    </ListingDetail>

                    <ListingDetail>
                      <ListingDetailBold>PRICE</ListingDetailBold>

                      <ListingDetailValue>
                        {pageData?.samples && pageData?.samples[1]?.price}
                      </ListingDetailValue>
                    </ListingDetail>

                    {pageData?.samples && pageData?.samples[1]?.cap && (
                      <ListingDetail>
                        <ListingDetailBold>CAP</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[0]?.cap}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}

                    {pageData?.samples && pageData?.samples[1]?.size && (
                      <ListingDetail>
                        <ListingDetailBold>Size</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[1]?.size}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}

                    {pageData?.samples && pageData?.samples[1]?.units && (
                      <ListingDetail>
                        <ListingDetailBold>Units</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[1]?.units}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}
                  </FancyContentHolder>
                </FancyChild>

                <FancyChild
                  onClick={() => {
                    StartQuiz("Listing card");
                  }}
                >
                  <FancyImg src={`/images/lp/${type}/sample3.jpg`} />

                  <FancyContentHolder>
                    <StartFlowButton>
                      {pageData?.samples && pageData?.samples[2]?.heading}
                      <BsChevronRight color="white" size="20px" />
                    </StartFlowButton>

                    <ListingDetail>
                      <ListingDetailBold>Location</ListingDetailBold>

                      <ListingDetailValue underLine={true}>
                        {pageData?.samples && pageData?.samples[2]?.location}
                      </ListingDetailValue>
                    </ListingDetail>

                    <ListingDetail>
                      <ListingDetailBold>PRICE</ListingDetailBold>

                      <ListingDetailValue>
                        {pageData?.samples && pageData?.samples[2]?.price}
                      </ListingDetailValue>
                    </ListingDetail>

                    {pageData?.samples && pageData?.samples[2]?.basement && (
                      <ListingDetail>
                        <ListingDetailBold>Basement</ListingDetailBold>

                        <ListingDetailValue>
                          {pageData?.samples[2]?.basement}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}

                    {pageData?.samples && pageData?.samples[2]?.size && (
                      <ListingDetail>
                        <ListingDetailBold>Size</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[2]?.size}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}

                    {pageData?.samples && pageData?.samples[2]?.units && (
                      <ListingDetail>
                        <ListingDetailBold>Units</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[2]?.units}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}
                  </FancyContentHolder>
                </FancyChild>
                <FancyChild
                  onClick={() => {
                    StartQuiz("Listing card");
                  }}
                >
                  <FancyImg
                    special={true}
                    src={`/images/lp/${type}/sample4.jpg`}
                  />

                  <FancyContentHolder special={true}>
                    <StartFlowButton>
                      {pageData?.samples && pageData?.samples[3]?.heading}
                      <BsChevronRight color="black" size="20px" />
                    </StartFlowButton>

                    <ListingDetail>
                      <ListingDetailBold>Location</ListingDetailBold>

                      <ListingDetailValue underLine={true}>
                        {pageData?.samples && pageData?.samples[3]?.location}
                      </ListingDetailValue>
                    </ListingDetail>

                    <ListingDetail>
                      <ListingDetailBold>PRICE</ListingDetailBold>

                      <ListingDetailValue>
                        {" "}
                        {pageData?.samples && pageData?.samples[3]?.price}
                      </ListingDetailValue>
                    </ListingDetail>

                    {pageData?.samples && pageData?.samples[3]?.size && (
                      <ListingDetail>
                        <ListingDetailBold>Size</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[3]?.size}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}
                    {pageData?.samples && pageData?.samples[3]?.units && (
                      <ListingDetail>
                        <ListingDetailBold>Units</ListingDetailBold>
                        <ListingDetailValue>
                          {pageData?.samples[3]?.units}
                        </ListingDetailValue>
                      </ListingDetail>
                    )}
                  </FancyContentHolder>
                </FancyChild>
              </FancyHolder>
            </GridContentHolder>
          </Wrapper>
        </WrapperFlexer>
        <CTAandProof>
          <CTAHolder>
            <PermanentCTAButton
              onClick={() => StartQuiz("CTA under Listings")}
              color="black"
            >
              {ctaText}
            </PermanentCTAButton>
          </CTAHolder>
        </CTAandProof>
      </ListingSample>

      <DarkSection>
        <WrapperFlexer>
          <Wrapper>
            <GridContentHolder>
              <BottomFlexer>
                <div>
                  <DarkSubtitleBottom>
                    START BY FINDING THE RIGHT {pageData?.ender} for you
                  </DarkSubtitleBottom>

                  <DarkTitleBottom>
                    Are you ready to find your next {pageData?.ender}?
                  </DarkTitleBottom>
                </div>

                <DarkCTAHolder>
                  <PermanentCTAButton
                    onClick={() => StartQuiz("CTA in Footer")}
                    color="red"
                  >
                    {ctaText}
                  </PermanentCTAButton>
                </DarkCTAHolder>
              </BottomFlexer>
            </GridContentHolder>
          </Wrapper>
        </WrapperFlexer>
      </DarkSection>
      <a
        onClick={() => {
          clientAnalytics.track("Review link visited on LP");
        }}
        href="https://goo.gl/maps/YYngTFK3k7PVwHfm7"
      >
        <StickyReviews>
          <ReviewsBadge/>
        </StickyReviews>
      </a>
    </Fonter>
  </>);
};

export default LP;

export async function getStaticPaths() {
  const starterPaths = [
    {
      params: {
        type: "multifamily",
      },
    },
    {
      params: {
        type: "office",
      },
    },
    {
      params: {
        type: "retail",
      },
    },
    {
      params: {
        type: "land",
      },
    },
    {
      params: {
        type: "industrial",
      },
    },
  ];

  return {
    paths: starterPaths,
    fallback: true,
  };
}

export async function getStaticProps({ params }) {
  String.prototype["toProperCase"] = function () {
    return this.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  // Check if params are a number

  const pageData = {
    industrial: {
      subText: "Find Industrial Units For Sale or Lease",
      hero: "Get personalized industrial listings that fit your needs",
      metaDesc: "Find industrial listings throughout Canada",
      floater: [
        "Looking for industrial spaces?",
        "Find the right listing for your needs",
      ],
      stepText: "ideal industrial units",
      helpText: "industrial units",
      samples: [
        {
          heading: "4800 Sq Ft Space in Meaford ",
          location: "Meaford, ON",
          price: "$8/Sq Ft",
          size: "4,800 Sq Ft",
        },
        {
          heading: "Industrial Freestanding Building for Sale ",
          location: "Toronto, ON",
          price: "Contact",
          size: "53,651 Sq Ft",
        },
        {
          heading: "Industrial Building for Lease In Oakville ",
          location: "Oakville, ON",
          price: "$10.95/Sq Ft",
          size: "7.4 Acres",
        },
        {
          heading: "Industrial Suite for Lease In Mississauga ",
          location: "Mississauga, ON",
          price: "$15.95/Sq Ft",
          size: "4,427 Sq Ft",
        },
      ],
      ender: "industrial units",
    },
    land: {
      subText: "Find Land Lots For Sale or Lease",
      hero: "Get personalized land listings that fit your needs",
      metaDesc: "Find land listings throughout Canada",

      floater: [
        "Looking for vacant land?",
        "Find the right listing for your needs",
      ],
      stepText: "ideal land lots",
      helpText: "land listings",
      samples: [
        {
          heading: "Serviced Industrial Land at Autopark ",
          location: "Whitchurch-Stouffville, ON",
          price: "Contact",
          size: "1 Acre",
        },
        {
          heading: "16 Acres Development Site ",
          location: "Point Edward, ON",
          price: "Contact",
          size: "16 Acres",
        },
        {
          heading: "62 Unit Condominium Development ",
          location: "Estevan, SK",
          price: "$2,200,000",
          size: "24 Acres",
        },
        {
          heading: "103 Acres Farm Land ",
          location: "Blind River, ON",
          price: "$949,000",
          size: "103 Acres",
        },
      ],
      ender: "land lots",
    },
    retail: {
      subText: "Find Retail Units For Sale or Lease",
      hero: "Get personalized retail listings that fit your needs",
      metaDesc: "Find retail opportunities throughout Canada",

      floater: [
        "Looking for retail spaces?",
        "Find the right space for your business",
      ],
      stepText: "ideal retail unit",
      helpText: "retail units",
      samples: [
        {
          heading: "Ground Floor Retail/Office For Lease ",
          location: "Toronto, ON",
          price: "$45/Sq ft",
          size: "3,500 Sq Ft",
        },
        {
          heading: "Ground Floor Retail/Office For Lease ",
          location: "Toronto, ON",
          price: "Contact",
          size: "2,361 Sq Ft",
        },
        {
          heading: "Retail/Office Unit In A Prime Location ",
          location: "Newmarket, ON",
          price: "$28/Sq ft",
          size: "1,228 Sq Ft",
        },
        {
          heading: "Bayview Leaside Retail Unit For Sale ",
          location: "Toronto, ON",
          price: "Contact",
          size: "1,745 Sq Ft",
        },
      ],
      ender: "retail space",
    },
    office: {
      subText: "Find Office Spaces For Sale or Lease",
      hero: "Get personalized office listings that fit your needs",
      metaDesc: "Find Office Spaces For sale",
      floater: [
        "Looking for office spaces?",
        "Find the right space for your business",
      ],
      stepText: "ideal office space",
      helpText: "office spaces",
      samples: [
        {
          heading: "Ground Floor Retail/Office For Lease ",
          location: "Toronto, ON",
          price: "$45/Sq ft",
          size: "3,500 Sq Ft",
        },
        {
          heading: "Ground Floor Retail/Office For Lease ",
          location: "Toronto, ON",
          price: "Contact",
          size: "2,361 Sq Ft",
        },
        {
          heading: "Well Situated Office Space For Sublease ",
          location: "Mississauga, ON",
          price: "$16.5/Sq ft",
          size: "6,000 Sq Ft",
        },
        {
          heading: "Medical Office Space For Sublease ",
          location: "Mississauga, ON",
          price: "$12/Sq ft",
          size: "1,179 Sq Ft",
        },
      ],
      ender: "office space",
    },
    multifamily: {
      subText: "Find Listings Worth Investing In",
      hero: "Get personalized multifamily listings that fit your portfolio",
      metaDesc: "Find multifamily opportunities throughout Canada",
      floater: [
        "Looking to improve your portfolio?",
        "Find the right property for you",
      ],
      stepText: "investment goals",
      helpText: "multifamily properties",
      samples: [
        {
          heading: "Multi-unit in Welland ",
          location: "Welland, ON",
          price: "$950,000",
          cap: "3.4%",
          units: "10",
        },
        {
          heading: "Triplex in Ottawa ",
          location: "Ottawa, ON",
          price: "$890,000",
          size: "4,500 Sq Ft",
          units: "3",
        },
        {
          heading: "Duplex in Huntingdon ",
          location: "Huntingdon, ON",
          price: "$229,000",
          basement: "Finished",
        },
        {
          heading: "12-unit in Ottawa ",
          location: "Welland, ON",
          price: "$6,750,000",
          size: "4,962 Sq Ft",
          units: "12",
        },
      ],
      ender: "multifamily investment",
    },
  };

  return {
    props: {
      type: params.type.toProperCase(),
      pageData: pageData[params.type.toLowerCase()],
    },
  };
}

LP.blankRoute = true;
